
export interface MessageReceiverModel {
  userID?: number;
  loginID?: number;
  name?: string;
  dateRead?: Date;
  relationshipToPatient?: string;
  isPatient?: boolean;
}
